import React from 'react'

import klarysLogo from 'src/images/klarys-logo.svg'
import { useMarketplaceQuery } from 'src/queries/shared'

import { HeaderLogo } from '.'

export interface AuthHeaderProps {
  'data-e2e'?: string
}

const AuthHeader = ({ 'data-e2e': dataE2e = 'auth-header' }: AuthHeaderProps) => {
  const { data: marketplace } = useMarketplaceQuery()

  return (
    <a data-e2e={dataE2e} href={window.WEBSITE_URL || '/'}>
      <HeaderLogo
        data-e2e="auth-header-logo"
        alt={marketplace?.[0]?.name ?? 'Klarys logo'}
        src={marketplace?.[0]?.logo ?? klarysLogo}
      />
    </a>
  )
}

export default AuthHeader
